export const icons = [
    { name: "24h24_7j7", icon: "/custom-icons/24h24_7j7.svg", type: "custom" },
    {
        name: "acceptation.cgs",
        icon: "/custom-icons/acceptation.cgs.svg",
        type: "custom",
    },
    {
        name: "accuse_de_reception",
        icon: "/custom-icons/accuse_de_reception.svg",
        type: "custom",
    },
    { name: "achat", icon: "/custom-icons/achat.svg", type: "custom" },
    {
        name: "affranchissement",
        icon: "/custom-icons/affranchissement.svg",
        type: "custom",
    },
    { name: "agenda", icon: "/custom-icons/agenda.svg", type: "custom" },
    {
        name: "aide_en_ligne",
        icon: "/custom-icons/aide_en_ligne.svg",
        type: "custom",
    },
    { name: "analyser", icon: "/custom-icons/analyser.svg", type: "custom" },
    { name: "annexe", icon: "/custom-icons/annexe.svg", type: "custom" },
    {
        name: "annexes_nominatives",
        icon: "/custom-icons/annexes_nominatives.svg",
        type: "custom",
    },
    {
        name: "annuaire_en_ligne",
        icon: "/custom-icons/annuaire_en_ligne.svg",
        type: "custom",
    },
    { name: "antivirus", icon: "/custom-icons/antivirus.svg", type: "custom" },
    { name: "api", icon: "/custom-icons/api.svg", type: "custom" },
    { name: "appel", icon: "/custom-icons/appel.svg", type: "custom" },
    {
        name: "applications",
        icon: "/custom-icons/applications.svg",
        type: "custom",
    },
    { name: "archivage", icon: "/custom-icons/archivage.svg", type: "custom" },
    {
        name: "archivage_cloud",
        icon: "/custom-icons/archivage_cloud.svg",
        type: "custom",
    },
    {
        name: "archivage_securise_1",
        icon: "/custom-icons/archivage_securise_1.svg",
        type: "custom",
    },
    {
        name: "archivage_securise_2",
        icon: "/custom-icons/archivage_securise_2.svg",
        type: "custom",
    },
    { name: "assurance", icon: "/custom-icons/assurance.svg", type: "custom" },
    {
        name: "atteinte_a_la_reputation",
        icon: "/custom-icons/atteinte_a_la_reputation.svg",
        type: "custom",
    },
    {
        name: "automatisation",
        icon: "/custom-icons/automatisation.svg",
        type: "custom",
    },
    {
        name: "back_office",
        icon: "/custom-icons/back_office.svg",
        type: "custom",
    },
    { name: "badge", icon: "/custom-icons/badge.svg", type: "custom" },
    { name: "banque", icon: "/custom-icons/banque.svg", type: "custom" },
    { name: "benefices", icon: "/custom-icons/benefices.svg", type: "custom" },
    {
        name: "bien_etre_au_travail",
        icon: "/custom-icons/bien_etre_au_travail.svg",
        type: "custom",
    },
    {
        name: "boite_aux_lettres",
        icon: "/custom-icons/boite_aux_lettres.svg",
        type: "custom",
    },
    { name: "bornage", icon: "/custom-icons/bornage.svg", type: "custom" },
    { name: "budget", icon: "/custom-icons/budget.svg", type: "custom" },
    {
        name: "bulletin_paie",
        icon: "/custom-icons/bulletin_paie.svg",
        type: "custom",
    },
    {
        name: "bulletin_paie_electronique",
        icon: "/custom-icons/bulletin_paie_electronique.svg",
        type: "custom",
    },
    {
        name: "bulletin_paie_securise",
        icon: "/custom-icons/bulletin_paie_securise.svg",
        type: "custom",
    },
    { name: "ca_dollars", icon: "/custom-icons/ca_dollars.svg", type: "custom" },
    { name: "ca_euros", icon: "/custom-icons/ca_euros.svg", type: "custom" },
    { name: "ca_livres", icon: "/custom-icons/ca_livres.svg", type: "custom" },
    { name: "cadenas", icon: "/custom-icons/cadenas.svg", type: "custom" },
    { name: "caduce", icon: "/custom-icons/caduce.svg", type: "custom" },
    { name: "cafe", icon: "/custom-icons/cafe.svg", type: "custom" },
    {
        name: "cahier_des_charges",
        icon: "/custom-icons/cahier_des_charges.svg",
        type: "custom",
    },
    {
        name: "capture_et_Controle",
        icon: "/custom-icons/capture_et_Controle.svg",
        type: "custom",
    },
    {
        name: "carte_bleue",
        icon: "/custom-icons/carte_bleue.svg",
        type: "custom",
    },
    {
        name: "carte_detachable",
        icon: "/custom-icons/carte_detachable.svg",
        type: "custom",
    },
    {
        name: "carte_identite",
        icon: "/custom-icons/carte_identite.svg",
        type: "custom",
    },
    {
        name: "carte_identite_verifiee",
        icon: "/custom-icons/carte_identite_verifiee.svg",
        type: "custom",
    },
    {
        name: "carte_vitale_dematerialisee",
        icon: "/custom-icons/carte_vitale_dematerialisee.svg",
        type: "custom",
    },
    {
        name: "casier_courrier",
        icon: "/custom-icons/casier_courrier.svg",
        type: "custom",
    },
    {
        name: "casier_electronique",
        icon: "/custom-icons/casier_electronique.svg",
        type: "custom",
    },
    {
        name: "casque_bluetooth",
        icon: "/custom-icons/casque_bluetooth.svg",
        type: "custom",
    },
    {
        name: "centre_de_production",
        icon: "/custom-icons/centre_de_production.svg",
        type: "custom",
    },
    {
        name: "certification_1",
        icon: "/custom-icons/certification_1.svg",
        type: "custom",
    },
    {
        name: "certification_2",
        icon: "/custom-icons/certification_2.svg",
        type: "custom",
    },
    {
        name: "chaine_de_confiance",
        icon: "/custom-icons/chaine_de_confiance.svg",
        type: "custom",
    },
    { name: "chantier", icon: "/custom-icons/chantier.svg", type: "custom" },
    {
        name: "chariot_elevateur",
        icon: "/custom-icons/chariot_elevateur.svg",
        type: "custom",
    },
    { name: "check_list", icon: "/custom-icons/check_list.svg", type: "custom" },
    { name: "cheque", icon: "/custom-icons/cheque.svg", type: "custom" },
    {
        name: "cheque_cadeau",
        icon: "/custom-icons/cheque_cadeau.svg",
        type: "custom",
    },
    {
        name: "cheques_traites",
        icon: "/custom-icons/cheques_traites.svg",
        type: "custom",
    },
    {
        name: "chronometre",
        icon: "/custom-icons/chronometre.svg",
        type: "custom",
    },
    { name: "cible", icon: "/custom-icons/cible.svg", type: "custom" },
    {
        name: "circuit_postal",
        icon: "/custom-icons/circuit_postal.svg",
        type: "custom",
    },
    {
        name: "circuit_signature",
        icon: "/custom-icons/circuit_signature.svg",
        type: "custom",
    },
    { name: "citation", icon: "/custom-icons/citation.svg", type: "custom" },
    { name: "citation_2", icon: "/custom-icons/citation_2.svg", type: "custom" },
    { name: "classement", icon: "/custom-icons/classement.svg", type: "custom" },
    { name: "cloud", icon: "/custom-icons/cloud.svg", type: "custom" },
    {
        name: "cloud_securise",
        icon: "/custom-icons/cloud_securise.svg",
        type: "custom",
    },
    { name: "code_acces", icon: "/custom-icons/code_acces.svg", type: "custom" },
    {
        name: "code_acces_courrier",
        icon: "/custom-icons/code_acces_courrier.svg",
        type: "custom",
    },
    {
        name: "coffre_fort",
        icon: "/custom-icons/coffre_fort.svg",
        type: "custom",
    },
    {
        name: "coffre_fort_electronique",
        icon: "/custom-icons/coffre_fort_electronique.svg",
        type: "custom",
    },
    { name: "colis", icon: "/custom-icons/colis.svg", type: "custom" },
    {
        name: "collaborateur",
        icon: "/custom-icons/collaborateur.svg",
        type: "custom",
    },
    {
        name: "collectif_collaboratif",
        icon: "/custom-icons/collectif_collaboratif.svg",
        type: "custom",
    },
    { name: "commercial", icon: "/custom-icons/commercial.svg", type: "custom" },
    {
        name: "communication_360",
        icon: "/custom-icons/communication_360.svg",
        type: "custom",
    },
    {
        name: "compatible_cpa",
        icon: "/custom-icons/compatible_cpa.svg",
        type: "custom",
    },
    { name: "confiance", icon: "/custom-icons/confiance.svg", type: "custom" },
    {
        name: "confiance_numerique",
        icon: "/custom-icons/confiance_numerique.svg",
        type: "custom",
    },
    {
        name: "conforme_cse",
        icon: "/custom-icons/conforme_cse.svg",
        type: "custom",
    },
    {
        name: "conforme_helios",
        icon: "/custom-icons/conforme_helios.svg",
        type: "custom",
    },
    {
        name: "connecteur_chorus",
        icon: "/custom-icons/connecteur_chorus.svg",
        type: "custom",
    },
    { name: "conseil", icon: "/custom-icons/conseil.svg", type: "custom" },
    { name: "contact", icon: "/custom-icons/contact.svg", type: "custom" },
    { name: "controle", icon: "/custom-icons/controle.svg", type: "custom" },
    { name: "coupe", icon: "/custom-icons/coupe.svg", type: "custom" },
    {
        name: "courbe_de_croissance",
        icon: "/custom-icons/courbe_de_croissance.svg",
        type: "custom",
    },
    { name: "courrier_1", icon: "/custom-icons/courrier_1.svg", type: "custom" },
    { name: "courrier_2", icon: "/custom-icons/courrier_2.svg", type: "custom" },
    {
        name: "courrier_securise",
        icon: "/custom-icons/courrier_securise.svg",
        type: "custom",
    },
    { name: "croissance", icon: "/custom-icons/croissance.svg", type: "custom" },
    { name: "cv", icon: "/custom-icons/cv.svg", type: "custom" },
    {
        name: "cyberattaque",
        icon: "/custom-icons/cyberattaque.svg",
        type: "custom",
    },
    {
        name: "cybercriminalite",
        icon: "/custom-icons/cybercriminalite.svg",
        type: "custom",
    },
    {
        name: "cybersauvegarde",
        icon: "/custom-icons/cybersauvegarde.svg",
        type: "custom",
    },
    {
        name: "cybersecurite",
        icon: "/custom-icons/cybersecurite.svg",
        type: "custom",
    },
    { name: "data", icon: "/custom-icons/data.svg", type: "custom" },
    {
        name: "data_centers",
        icon: "/custom-icons/data_centers.svg",
        type: "custom",
    },
    {
        name: "data_ethique",
        icon: "/custom-icons/data_ethique.svg",
        type: "custom",
    },
    {
        name: "decoupe_document",
        icon: "/custom-icons/decoupe_document.svg",
        type: "custom",
    },
    {
        name: "decroissance",
        icon: "/custom-icons/decroissance.svg",
        type: "custom",
    },
    { name: "delai", icon: "/custom-icons/delai.svg", type: "custom" },
    {
        name: "delai_rappel",
        icon: "/custom-icons/delai_rappel.svg",
        type: "custom",
    },
    {
        name: "delegation_de_service",
        icon: "/custom-icons/delegation_de_service.svg",
        type: "custom",
    },
    {
        name: "demande_validee",
        icon: "/custom-icons/demande_validee.svg",
        type: "custom",
    },
    {
        name: "dematerialisation_bdp",
        icon: "/custom-icons/dematerialisation_bdp.svg",
        type: "custom",
    },
    { name: "dependance", icon: "/custom-icons/dependance.svg", type: "custom" },
    { name: "depliant", icon: "/custom-icons/depliant.svg", type: "custom" },
    {
        name: "depot_facture",
        icon: "/custom-icons/depot_facture.svg",
        type: "custom",
    },
    { name: "designer", icon: "/custom-icons/designer.svg", type: "custom" },
    {
        name: "destabilisation",
        icon: "/custom-icons/destabilisation.svg",
        type: "custom",
    },
    {
        name: "destinataire",
        icon: "/custom-icons/destinataire.svg",
        type: "custom",
    },
    {
        name: "destruction",
        icon: "/custom-icons/destruction.svg",
        type: "custom",
    },
    { name: "devices_1", icon: "/custom-icons/devices_1.svg", type: "custom" },
    { name: "devices_2", icon: "/custom-icons/devices_2.svg", type: "custom" },
    { name: "dialoguer", icon: "/custom-icons/dialoguer.svg", type: "custom" },
    { name: "document", icon: "/custom-icons/document.svg", type: "custom" },
    {
        name: "document_numerise",
        icon: "/custom-icons/document_numerise.svg",
        type: "custom",
    },
    { name: "documents", icon: "/custom-icons/documents.svg", type: "custom" },
    {
        name: "documents_certifies",
        icon: "/custom-icons/documents_certifies.svg",
        type: "custom",
    },
    {
        name: "documents_collectes",
        icon: "/custom-icons/documents_collectes.svg",
        type: "custom",
    },
    {
        name: "documents_personnels",
        icon: "/custom-icons/documents_personnels.svg",
        type: "custom",
    },
    {
        name: "documents_personnels_scannes",
        icon: "/custom-icons/documents_personnels_scannes.svg",
        type: "custom",
    },
    {
        name: "documents_securises",
        icon: "/custom-icons/documents_securises.svg",
        type: "custom",
    },
    {
        name: "donnees_de_recherches",
        icon: "/custom-icons/donnees_de_recherches.svg",
        type: "custom",
    },
    {
        name: "donnees_de_sante_connectee",
        icon: "/custom-icons/donnees_de_sante_connectee.svg",
        type: "custom",
    },
    {
        name: "donnees_epidemiologique",
        icon: "/custom-icons/donnees_epidemiologique.svg",
        type: "custom",
    },
    {
        name: "donnees_genetiques",
        icon: "/custom-icons/donnees_genetiques.svg",
        type: "custom",
    },
    {
        name: "donnees_imagerie",
        icon: "/custom-icons/donnees_imagerie.svg",
        type: "custom",
    },
    {
        name: "donnees_personnelles_de_sante",
        icon: "/custom-icons/donnees_personnelles_de_sante.svg",
        type: "custom",
    },
    { name: "dossier", icon: "/custom-icons/dossier.svg", type: "custom" },
    {
        name: "dossier_sante",
        icon: "/custom-icons/dossier_sante.svg",
        type: "custom",
    },
    {
        name: "dossier_securise",
        icon: "/custom-icons/dossier_securise.svg",
        type: "custom",
    },
    { name: "editique", icon: "/custom-icons/editique.svg", type: "custom" },
    { name: "education", icon: "/custom-icons/education.svg", type: "custom" },
    { name: "email", icon: "/custom-icons/email.svg", type: "custom" },
    {
        name: "email_notification",
        icon: "/custom-icons/email_notification.svg",
        type: "custom",
    },
    { name: "emploi", icon: "/custom-icons/emploi.svg", type: "custom" },
    {
        name: "en_cours_de_validation",
        icon: "/custom-icons/en_cours_de_validation.svg",
        type: "custom",
    },
    {
        name: "en_ligne_securise",
        icon: "/custom-icons/en_ligne_securise.svg",
        type: "custom",
    },
    {
        name: "en_savoir_plus",
        icon: "/custom-icons/en_savoir_plus.svg",
        type: "custom",
    },
    {
        name: "encaissement",
        icon: "/custom-icons/encaissement.svg",
        type: "custom",
    },
    {
        name: "encaissement_en_ligne",
        icon: "/custom-icons/encaissement_en_ligne.svg",
        type: "custom",
    },
    { name: "enceinte", icon: "/custom-icons/enceinte.svg", type: "custom" },
    { name: "entreprise", icon: "/custom-icons/entreprise.svg", type: "custom" },
    {
        name: "environnement",
        icon: "/custom-icons/environnement.svg",
        type: "custom",
    },
    { name: "epi", icon: "/custom-icons/epi.svg", type: "custom" },
    { name: "equipe", icon: "/custom-icons/equipe.svg", type: "custom" },
    {
        name: "etablissement",
        icon: "/custom-icons/etablissement.svg",
        type: "custom",
    },
    { name: "ethique", icon: "/custom-icons/ethique.svg", type: "custom" },
    {
        name: "etudiants_diplomes",
        icon: "/custom-icons/etudiants_diplomes.svg",
        type: "custom",
    },
    { name: "europe", icon: "/custom-icons/europe.svg", type: "custom" },
    {
        name: "evaluation_des_risques",
        icon: "/custom-icons/evaluation_des_risques.svg",
        type: "custom",
    },
    { name: "ewallet", icon: "/custom-icons/ewallet.svg", type: "custom" },
    {
        name: "experience_prospect",
        icon: "/custom-icons/experience_prospect.svg",
        type: "custom",
    },
    { name: "expertise", icon: "/custom-icons/expertise.svg", type: "custom" },
    {
        name: "expertise_client",
        icon: "/custom-icons/expertise_client.svg",
        type: "custom",
    },
    {
        name: "export_de_donnees",
        icon: "/custom-icons/export_de_donnees.svg",
        type: "custom",
    },
    { name: "facture", icon: "/custom-icons/facture.svg", type: "custom" },
    {
        name: "facture_electronique",
        icon: "/custom-icons/facture_electronique.svg",
        type: "custom",
    },
    { name: "famille", icon: "/custom-icons/famille.svg", type: "custom" },
    { name: "fax", icon: "/custom-icons/fax.svg", type: "custom" },
    { name: "feliciter", icon: "/custom-icons/feliciter.svg", type: "custom" },
    { name: "finance", icon: "/custom-icons/finance.svg", type: "custom" },
    { name: "flash_code", icon: "/custom-icons/flash_code.svg", type: "custom" },
    { name: "flux", icon: "/custom-icons/flux.svg", type: "custom" },
    { name: "formation", icon: "/custom-icons/formation.svg", type: "custom" },
    { name: "formulaire", icon: "/custom-icons/formulaire.svg", type: "custom" },
    {
        name: "formulaire_de_contact",
        icon: "/custom-icons/formulaire_de_contact.svg",
        type: "custom",
    },
    {
        name: "fqb_renseignee",
        icon: "/custom-icons/fqb_renseignee.svg",
        type: "custom",
    },
    { name: "france", icon: "/custom-icons/france.svg", type: "custom" },
    {
        name: "fraude_bancaire",
        icon: "/custom-icons/fraude_bancaire.svg",
        type: "custom",
    },
    {
        name: "fraude_identitaire",
        icon: "/custom-icons/fraude_identitaire.svg",
        type: "custom",
    },
    { name: "fusee", icon: "/custom-icons/fusee.svg", type: "custom" },
    {
        name: "fusion_documents",
        icon: "/custom-icons/fusion_documents.svg",
        type: "custom",
    },
    { name: "ged", icon: "/custom-icons/ged.svg", type: "custom" },
    {
        name: "geolocalisation",
        icon: "/custom-icons/geolocalisation.svg",
        type: "custom",
    },
    {
        name: "gestion.pnd",
        icon: "/custom-icons/gestion.pnd.svg",
        type: "custom",
    },
    { name: "gestion", icon: "/custom-icons/gestion.svg", type: "custom" },
    {
        name: "gestion_de_contrat",
        icon: "/custom-icons/gestion_de_contrat.svg",
        type: "custom",
    },
    { name: "goutte", icon: "/custom-icons/goutte.svg", type: "custom" },
    { name: "hacker", icon: "/custom-icons/hacker.svg", type: "custom" },
    { name: "hopital", icon: "/custom-icons/hopital.svg", type: "custom" },
    { name: "horloge", icon: "/custom-icons/horloge.svg", type: "custom" },
    { name: "horodatage", icon: "/custom-icons/horodatage.svg", type: "custom" },
    { name: "ia", icon: "/custom-icons/ia.svg", type: "custom" },
    {
        name: "id_numerique_verifiee",
        icon: "/custom-icons/id_numerique_verifiee.svg",
        type: "custom",
    },
    { name: "idee", icon: "/custom-icons/idee.svg", type: "custom" },
    {
        name: "impact_economique",
        icon: "/custom-icons/impact_economique.svg",
        type: "custom",
    },
    {
        name: "impact_juridique",
        icon: "/custom-icons/impact_juridique.svg",
        type: "custom",
    },
    {
        name: "impact_sanitaire",
        icon: "/custom-icons/impact_sanitaire.svg",
        type: "custom",
    },
    {
        name: "impact_social",
        icon: "/custom-icons/impact_social.svg",
        type: "custom",
    },
    {
        name: "impacts_reglementaires",
        icon: "/custom-icons/impacts_reglementaires.svg",
        type: "custom",
    },
    { name: "imprimante", icon: "/custom-icons/imprimante.svg", type: "custom" },
    { name: "incendie", icon: "/custom-icons/incendie.svg", type: "custom" },
    { name: "incident", icon: "/custom-icons/incident.svg", type: "custom" },
    {
        name: "inclusion_interet_general",
        icon: "/custom-icons/inclusion_interet_general.svg",
        type: "custom",
    },
    {
        name: "indexation_documents",
        icon: "/custom-icons/indexation_documents.svg",
        type: "custom",
    },
    {
        name: "information",
        icon: "/custom-icons/information.svg",
        type: "custom",
    },
    { name: "innovation", icon: "/custom-icons/innovation.svg", type: "custom" },
    { name: "input", icon: "/custom-icons/input.svg", type: "custom" },
    {
        name: "international",
        icon: "/custom-icons/international.svg",
        type: "custom",
    },
    {
        name: "intrusion_informatique",
        icon: "/custom-icons/intrusion_informatique.svg",
        type: "custom",
    },
    {
        name: "issue_de_secours",
        icon: "/custom-icons/issue_de_secours.svg",
        type: "custom",
    },
    {
        name: "jeux_en_ligne",
        icon: "/custom-icons/jeux_en_ligne.svg",
        type: "custom",
    },
    { name: "jpg", icon: "/custom-icons/jpg.svg", type: "custom" },
    { name: "juridique", icon: "/custom-icons/juridique.svg", type: "custom" },
    {
        name: "laver_les_mains",
        icon: "/custom-icons/laver_les_mains.svg",
        type: "custom",
    },
    {
        name: "lettre_recommandee",
        icon: "/custom-icons/lettre_recommandee.svg",
        type: "custom",
    },
    {
        name: "lettre_recommandee_electronique",
        icon: "/custom-icons/lettre_recommandee_electronique.svg",
        type: "custom",
    },
    {
        name: "lettre_timbree",
        icon: "/custom-icons/lettre_timbree.svg",
        type: "custom",
    },
    { name: "liseuse", icon: "/custom-icons/liseuse.svg", type: "custom" },
    {
        name: "livre_blanc",
        icon: "/custom-icons/livre_blanc.svg",
        type: "custom",
    },
    {
        name: "localisation",
        icon: "/custom-icons/localisation.svg",
        type: "custom",
    },
    { name: "locataire", icon: "/custom-icons/locataire.svg", type: "custom" },
    { name: "main", icon: "/custom-icons/main.svg", type: "custom" },
    { name: "malware", icon: "/custom-icons/malware.svg", type: "custom" },
    { name: "management", icon: "/custom-icons/management.svg", type: "custom" },
    {
        name: "mandat_sepa",
        icon: "/custom-icons/mandat_sepa.svg",
        type: "custom",
    },
    {
        name: "mandat_sepa_gestion",
        icon: "/custom-icons/mandat_sepa_gestion.svg",
        type: "custom",
    },
    {
        name: "mandat_sepa_traite",
        icon: "/custom-icons/mandat_sepa_traite.svg",
        type: "custom",
    },
    { name: "medecin", icon: "/custom-icons/medecin.svg", type: "custom" },
    {
        name: "mise_a_jour",
        icon: "/custom-icons/mise_a_jour.svg",
        type: "custom",
    },
    {
        name: "mise_sous_pli",
        icon: "/custom-icons/mise_sous_pli.svg",
        type: "custom",
    },
    {
        name: "mobilite_reduite",
        icon: "/custom-icons/mobilite_reduite.svg",
        type: "custom",
    },
    {
        name: "modifications",
        icon: "/custom-icons/modifications.svg",
        type: "custom",
    },
    { name: "monnaie", icon: "/custom-icons/monnaie.svg", type: "custom" },
    { name: "moto", icon: "/custom-icons/moto.svg", type: "custom" },
    {
        name: "note_de_frais",
        icon: "/custom-icons/note_de_frais.svg",
        type: "custom",
    },
    {
        name: "notification",
        icon: "/custom-icons/notification.svg",
        type: "custom",
    },
    {
        name: "numerique_engage",
        icon: "/custom-icons/numerique_engage.svg",
        type: "custom",
    },
    {
        name: "numerique_responsable",
        icon: "/custom-icons/numerique_responsable.svg",
        type: "custom",
    },
    { name: "obseques", icon: "/custom-icons/obseques.svg", type: "custom" },
    {
        name: "offre_packagee",
        icon: "/custom-icons/offre_packagee.svg",
        type: "custom",
    },
    {
        name: "offre_sur_mesure",
        icon: "/custom-icons/offre_sur_mesure.svg",
        type: "custom",
    },
    { name: "operateur", icon: "/custom-icons/operateur.svg", type: "custom" },
    {
        name: "opportunites",
        icon: "/custom-icons/opportunites.svg",
        type: "custom",
    },
    { name: "options", icon: "/custom-icons/options.svg", type: "custom" },
    {
        name: "options_bureautique",
        icon: "/custom-icons/options_bureautique.svg",
        type: "custom",
    },
    { name: "ordinateur", icon: "/custom-icons/ordinateur.svg", type: "custom" },
    {
        name: "ordinateur_portable",
        icon: "/custom-icons/ordinateur_portable.svg",
        type: "custom",
    },
    {
        name: "organigramme",
        icon: "/custom-icons/organigramme.svg",
        type: "custom",
    },
    { name: "outils", icon: "/custom-icons/outils.svg", type: "custom" },
    { name: "output", icon: "/custom-icons/output.svg", type: "custom" },
    { name: "page_web_1", icon: "/custom-icons/page_web_1.svg", type: "custom" },
    { name: "page_web_2", icon: "/custom-icons/page_web_2.svg", type: "custom" },
    { name: "paiement", icon: "/custom-icons/paiement.svg", type: "custom" },
    {
        name: "paiement_en_ligne",
        icon: "/custom-icons/paiement_en_ligne.svg",
        type: "custom",
    },
    {
        name: "paralysie_d_activite",
        icon: "/custom-icons/paralysie_d_activite.svg",
        type: "custom",
    },
    {
        name: "parametrage",
        icon: "/custom-icons/parametrage.svg",
        type: "custom",
    },
    { name: "parcours", icon: "/custom-icons/parcours.svg", type: "custom" },
    { name: "parite", icon: "/custom-icons/parite.svg", type: "custom" },
    { name: "partage", icon: "/custom-icons/partage.svg", type: "custom" },
    {
        name: "partenaires",
        icon: "/custom-icons/partenaires.svg",
        type: "custom",
    },
    { name: "pdf", icon: "/custom-icons/pdf.svg", type: "custom" },
    { name: "persona", icon: "/custom-icons/persona.svg", type: "custom" },
    { name: "phishing", icon: "/custom-icons/phishing.svg", type: "custom" },
    { name: "pinceau", icon: "/custom-icons/pinceau.svg", type: "custom" },
    { name: "pionnier", icon: "/custom-icons/pionnier.svg", type: "custom" },
    {
        name: "plateforme_de_services",
        icon: "/custom-icons/plateforme_de_services.svg",
        type: "custom",
    },
    { name: "pme", icon: "/custom-icons/pme.svg", type: "custom" },
    { name: "png", icon: "/custom-icons/png.svg", type: "custom" },
    { name: "podium", icon: "/custom-icons/podium.svg", type: "custom" },
    {
        name: "portefeuille",
        icon: "/custom-icons/portefeuille.svg",
        type: "custom",
    },
    { name: "positif", icon: "/custom-icons/positif.svg", type: "custom" },
    {
        name: "prelevement",
        icon: "/custom-icons/prelevement.svg",
        type: "custom",
    },
    { name: "prerequis", icon: "/custom-icons/prerequis.svg", type: "custom" },
    {
        name: "presentation",
        icon: "/custom-icons/presentation.svg",
        type: "custom",
    },
    { name: "presse", icon: "/custom-icons/presse.svg", type: "custom" },
    { name: "prevoyance", icon: "/custom-icons/prevoyance.svg", type: "custom" },
    { name: "processus", icon: "/custom-icons/processus.svg", type: "custom" },
    {
        name: "processus_documentaire",
        icon: "/custom-icons/processus_documentaire.svg",
        type: "custom",
    },
    { name: "protection", icon: "/custom-icons/protection.svg", type: "custom" },
    {
        name: "protection_cage_faraday",
        icon: "/custom-icons/protection_cage_faraday.svg",
        type: "custom",
    },
    {
        name: "protection_electromagnetique",
        icon: "/custom-icons/protection_electromagnetique.svg",
        type: "custom",
    },
    { name: "pv_recette", icon: "/custom-icons/pv_recette.svg", type: "custom" },
    { name: "question", icon: "/custom-icons/question.svg", type: "custom" },
    {
        name: "rancongiciel",
        icon: "/custom-icons/rancongiciel.svg",
        type: "custom",
    },
    {
        name: "rapprochement",
        icon: "/custom-icons/rapprochement.svg",
        type: "custom",
    },
    {
        name: "rdv_en_ligne",
        icon: "/custom-icons/rdv_en_ligne.svg",
        type: "custom",
    },
    {
        name: "realite_virtuelle",
        icon: "/custom-icons/realite_virtuelle.svg",
        type: "custom",
    },
    { name: "recherche", icon: "/custom-icons/recherche.svg", type: "custom" },
    {
        name: "recommandation",
        icon: "/custom-icons/recommandation.svg",
        type: "custom",
    },
    {
        name: "reduction_de_cout",
        icon: "/custom-icons/reduction_de_cout.svg",
        type: "custom",
    },
    {
        name: "relation_client",
        icon: "/custom-icons/relation_client.svg",
        type: "custom",
    },
    {
        name: "relation_collaborateur",
        icon: "/custom-icons/relation_collaborateur.svg",
        type: "custom",
    },
    {
        name: "remise_courrier",
        icon: "/custom-icons/remise_courrier.svg",
        type: "custom",
    },
    { name: "reporting", icon: "/custom-icons/reporting.svg", type: "custom" },
    { name: "reseau", icon: "/custom-icons/reseau.svg", type: "custom" },
    {
        name: "reseau_connecte",
        icon: "/custom-icons/reseau_connecte.svg",
        type: "custom",
    },
    {
        name: "reseaux_sociaux",
        icon: "/custom-icons/reseaux_sociaux.svg",
        type: "custom",
    },
    {
        name: "respect_des_lieux",
        icon: "/custom-icons/respect_des_lieux.svg",
        type: "custom",
    },
    {
        name: "restauration__dossier",
        icon: "/custom-icons/restauration__dossier.svg",
        type: "custom",
    },
    {
        name: "restauration__fichier",
        icon: "/custom-icons/restauration__fichier.svg",
        type: "custom",
    },
    {
        name: "restauration__globale",
        icon: "/custom-icons/restauration__globale.svg",
        type: "custom",
    },
    {
        name: "retour_experience",
        icon: "/custom-icons/retour_experience.svg",
        type: "custom",
    },
    { name: "retraite", icon: "/custom-icons/retraite.svg", type: "custom" },
    { name: "reunion", icon: "/custom-icons/reunion.svg", type: "custom" },
    { name: "ria", icon: "/custom-icons/ria.svg", type: "custom" },
    { name: "rse", icon: "/custom-icons/rse.svg", type: "custom" },
    { name: "sante", icon: "/custom-icons/sante.svg", type: "custom" },
    {
        name: "satisfaction_1",
        icon: "/custom-icons/satisfaction_1.svg",
        type: "custom",
    },
    {
        name: "satisfaction_2",
        icon: "/custom-icons/satisfaction_2.svg",
        type: "custom",
    },
    {
        name: "satisfaction_client",
        icon: "/custom-icons/satisfaction_client.svg",
        type: "custom",
    },
    { name: "sauvegarde", icon: "/custom-icons/sauvegarde.svg", type: "custom" },
    {
        name: "savoir_faire",
        icon: "/custom-icons/savoir_faire.svg",
        type: "custom",
    },
    {
        name: "secteur_public",
        icon: "/custom-icons/secteur_public.svg",
        type: "custom",
    },
    { name: "securite", icon: "/custom-icons/securite.svg", type: "custom" },
    {
        name: "securite_machines",
        icon: "/custom-icons/securite_machines.svg",
        type: "custom",
    },
    { name: "sepa", icon: "/custom-icons/sepa.svg", type: "custom" },
    { name: "serveur_1", icon: "/custom-icons/serveur_1.svg", type: "custom" },
    { name: "serveur_2", icon: "/custom-icons/serveur_2.svg", type: "custom" },
    {
        name: "service_client",
        icon: "/custom-icons/service_client.svg",
        type: "custom",
    },
    {
        name: "session_verrouillee",
        icon: "/custom-icons/session_verrouillee.svg",
        type: "custom",
    },
    { name: "si", icon: "/custom-icons/si.svg", type: "custom" },
    {
        name: "signature_1",
        icon: "/custom-icons/signature_1.svg",
        type: "custom",
    },
    {
        name: "signature_2",
        icon: "/custom-icons/signature_2.svg",
        type: "custom",
    },
    {
        name: "signature_contrat",
        icon: "/custom-icons/signature_contrat.svg",
        type: "custom",
    },
    {
        name: "signature_contrat_scellee",
        icon: "/custom-icons/signature_contrat_scellee.svg",
        type: "custom",
    },
    {
        name: "signature_electronique",
        icon: "/custom-icons/signature_electronique.svg",
        type: "custom",
    },
    {
        name: "signature_electronique_certifiee",
        icon: "/custom-icons/signature_electronique_certifiee.svg",
        type: "custom",
    },
    { name: "simplicite", icon: "/custom-icons/simplicite.svg", type: "custom" },
    { name: "sites_web", icon: "/custom-icons/sites_web.svg", type: "custom" },
    { name: "smartphone", icon: "/custom-icons/smartphone.svg", type: "custom" },
    { name: "souscrire", icon: "/custom-icons/souscrire.svg", type: "custom" },
    {
        name: "souverainete",
        icon: "/custom-icons/souverainete.svg",
        type: "custom",
    },
    { name: "spam", icon: "/custom-icons/spam.svg", type: "custom" },
    {
        name: "stethoscope",
        icon: "/custom-icons/stethoscope.svg",
        type: "custom",
    },
    {
        name: "stockage_temporaire",
        icon: "/custom-icons/stockage_temporaire.svg",
        type: "custom",
    },
    { name: "stylo", icon: "/custom-icons/stylo.svg", type: "custom" },
    {
        name: "suivi_d_envoi",
        icon: "/custom-icons/suivi_d_envoi.svg",
        type: "custom",
    },
    {
        name: "suivi_espace_client",
        icon: "/custom-icons/suivi_espace_client.svg",
        type: "custom",
    },
    {
        name: "suivi_signature",
        icon: "/custom-icons/suivi_signature.svg",
        type: "custom",
    },
    {
        name: "support_comite_financier",
        icon: "/custom-icons/support_comite_financier.svg",
        type: "custom",
    },
    {
        name: "support_comite_qualification",
        icon: "/custom-icons/support_comite_qualification.svg",
        type: "custom",
    },
    {
        name: "support_comite_solution",
        icon: "/custom-icons/support_comite_solution.svg",
        type: "custom",
    },
    {
        name: "support_stockage",
        icon: "/custom-icons/support_stockage.svg",
        type: "custom",
    },
    {
        name: "suppression_doublons",
        icon: "/custom-icons/suppression_doublons.svg",
        type: "custom",
    },
    {
        name: "symetrie_des_attentions",
        icon: "/custom-icons/symetrie_des_attentions.svg",
        type: "custom",
    },
    { name: "tablette", icon: "/custom-icons/tablette.svg", type: "custom" },
    {
        name: "tampon_valide",
        icon: "/custom-icons/tampon_valide.svg",
        type: "custom",
    },
    {
        name: "technologie",
        icon: "/custom-icons/technologie.svg",
        type: "custom",
    },
    {
        name: "telechargement",
        icon: "/custom-icons/telechargement.svg",
        type: "custom",
    },
    {
        name: "telechargement_document",
        icon: "/custom-icons/telechargement_document.svg",
        type: "custom",
    },
    {
        name: "telechargement_dossier",
        icon: "/custom-icons/telechargement_dossier.svg",
        type: "custom",
    },
    {
        name: "tracabilite",
        icon: "/custom-icons/tracabilite.svg",
        type: "custom",
    },
    { name: "traitement", icon: "/custom-icons/traitement.svg", type: "custom" },
    {
        name: "traitement_paiement",
        icon: "/custom-icons/traitement_paiement.svg",
        type: "custom",
    },
    {
        name: "travail_collaboratif",
        icon: "/custom-icons/travail_collaboratif.svg",
        type: "custom",
    },
    {
        name: "travail_sur_ecran",
        icon: "/custom-icons/travail_sur_ecran.svg",
        type: "custom",
    },
    { name: "travaux", icon: "/custom-icons/travaux.svg", type: "custom" },
    {
        name: "tri_courrier",
        icon: "/custom-icons/tri_courrier.svg",
        type: "custom",
    },
    {
        name: "usages_numeriques",
        icon: "/custom-icons/usages_numeriques.svg",
        type: "custom",
    },
    {
        name: "utilisateur_1",
        icon: "/custom-icons/utilisateur_1.svg",
        type: "custom",
    },
    {
        name: "utilisateur_2",
        icon: "/custom-icons/utilisateur_2.svg",
        type: "custom",
    },
    { name: "validation", icon: "/custom-icons/validation.svg", type: "custom" },
    {
        name: "valorisation",
        icon: "/custom-icons/valorisation.svg",
        type: "custom",
    },
    {
        name: "vehicule_la.poste",
        icon: "/custom-icons/vehicule_la.poste.svg",
        type: "custom",
    },
    {
        name: "vehicule_transporteur",
        icon: "/custom-icons/vehicule_transporteur.svg",
        type: "custom",
    },
    {
        name: "verification_iban",
        icon: "/custom-icons/verification_iban.svg",
        type: "custom",
    },
    {
        name: "verification_personne",
        icon: "/custom-icons/verification_personne.svg",
        type: "custom",
    },
    {
        name: "versionning",
        icon: "/custom-icons/versionning.svg",
        type: "custom",
    },
    { name: "video", icon: "/custom-icons/video.svg", type: "custom" },
    {
        name: "video_codage",
        icon: "/custom-icons/video_codage.svg",
        type: "custom",
    },
    { name: "vision", icon: "/custom-icons/vision.svg", type: "custom" },
    { name: "voiture", icon: "/custom-icons/voiture.svg", type: "custom" },
    {
        name: "vol_de_donnees",
        icon: "/custom-icons/vol_de_donnees.svg",
        type: "custom",
    },
    {
        name: "vote_electronique",
        icon: "/custom-icons/vote_electronique.svg",
        type: "custom",
    },
    {
        name: "vote_hybride",
        icon: "/custom-icons/vote_hybride.svg",
        type: "custom",
    },
    {
        name: "vote_papier",
        icon: "/custom-icons/vote_papier.svg",
        type: "custom",
    },
    { name: "vue", icon: "/custom-icons/vue.svg", type: "custom" },
    { name: "web", icon: "/custom-icons/web.svg", type: "custom" },
    { name: "wi_fi", icon: "/custom-icons/wi_fi.svg", type: "custom" },
    { name: "word", icon: "/custom-icons/word.svg", type: "custom" },
    { name: "workflow", icon: "/custom-icons/workflow.svg", type: "custom" },
    { name: "xls", icon: "/custom-icons/xls.svg", type: "custom" },
    { name: "zip", icon: "/custom-icons/zip.svg", type: "custom" },
];
